import React from "react";
import styles from "./Section.module.scss";
import { FieldTemplate } from "db/definitions";
import { Colors } from "@factorearth/component-library";

interface SectionProps {
	color: Colors;
	fieldInstanceId: string;
	fieldTemplate: FieldTemplate;
}

function Section(props: SectionProps) {
	const { color, fieldInstanceId, fieldTemplate } = props;

	return (
		<div key={fieldInstanceId} className={styles.inputWrapper} data-fieldtemplateid={fieldTemplate.id}>
			<div style={{ color: color.text.primary }} className={styles.header}>
				<div>{fieldTemplate.header}</div>
			</div>
		</div>
	);
}

export default Section;
